import React, { useEffect, useRef } from "react";
import MetaPost from "../header/MetaPost";
import BgImage from "../header/BgImage";
import { dsnCN } from "../../hooks/helper";

function PortfolioItem({ portoDetails, textButton, imageOnly, className }) {
  const ref = useRef();

  useEffect(() => {
    const video = ref.current.querySelector("video");
    if (!video) return;

    video.pause();
    const portItem = ref.current,
      mouseEnter = () => video.play(),
      mouseLeve = () => video.pause();

    portItem.addEventListener("mouseenter", mouseEnter);
    portItem.addEventListener("mouseleave", mouseLeve);

    return () => {
      if (!video) return;
      portItem.removeEventListener("mouseenter", mouseEnter);
      portItem.removeEventListener("mouseleave", mouseLeve);
    };
  }); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={dsnCN("portfolio-item text-center v-dark-head", className)}
      ref={ref}
    >
      <div className="item-border" />
      <div className="inner-img">
        <BgImage
          className={"dsn-swiper-parallax-transform"}
          src={portoDetails.src || "/assets/img/coming-soon.jpg"}
        />
      </div>
      <div className="info-text">
        {portoDetails.category && (
          <MetaPost category={portoDetails.category} separate=", " />
        )}

        {portoDetails.title && (
          <h4 className="title-block">
            {portoDetails.link ? (
              <a href={portoDetails.link} target="_blank" rel="noreferrer">
                {portoDetails.title}
              </a>
            ) : (
              portoDetails.title
            )}
          </h4>
        )}

        {portoDetails.link && (
          <a
            rel="noreferrer"
            className="btn-portfolio"
            href={portoDetails.link}
            target="_blank"
          >
            {textButton}
          </a>
        )}
      </div>
    </div>
  );
}

export default React.memo(PortfolioItem);
